import { forwardRef, Suspense, useContext, useEffect, useImperativeHandle, useRef, useState } from "react";
import { Store } from "../../../store";
import "./LayoutToolBar.css";

//AntDesign Imports
import { Button, Spin, Tabs } from "antd";
import LayoutTool from "./LayoutTool/LayoutTool";

// Lazy loading
import { lazy } from "react";
const ElementConfigPanel = lazy(() => import("../ConfigPanel/ElementConfigPanel"));

const LayoutToolBar = forwardRef(({ setShowShelf, setDeleteElement, loading, saveAll, setShowElementConfigPanel, showElementConfigPanel }, ref) => {
  const { state, dispatch } = useContext(Store);
  const [showColorPicker, setShowColorPicker] = useState(false);
  const colorPickerRef = useRef(null);

  useImperativeHandle(ref, () => {
    return {
      onTabChangeHandler,
    };
  });

  //Current Active Tab
  const [activeTab, setActiveTab] = useState("1");

  //TabConfig
  const tabConfig = [
    {
      key: "1",
      label: "Racks",
      children: (
        <LayoutTool
          setShowShelf={setShowShelf}
          setDeleteElement={setDeleteElement}
          elementType={"rack"}
          setShowElementConfigPanel={setShowElementConfigPanel}
        />
      ),
    },
    {
      key: "2",
      label: "Walls",
      children: (
        <LayoutTool
          setShowShelf={setShowShelf}
          setDeleteElement={setDeleteElement}
          elementType={"wall"}
          setShowElementConfigPanel={setShowElementConfigPanel}
        />
      ),
    },
    {
      key: "3",
      label: "Areas",
      children: (
        <LayoutTool
          setShowShelf={setShowShelf}
          setDeleteElement={setDeleteElement}
          elementType={"area"}
          setShowElementConfigPanel={setShowElementConfigPanel}
        />
      ),
    },
    {
      key: "4",
      label: "Zones",
      children: (
        <LayoutTool
          setShowShelf={setShowShelf}
          setDeleteElement={setDeleteElement}
          elementType={"zone"}
          setShowElementConfigPanel={setShowElementConfigPanel}
        />
      ),
    },
    {
      key: "5",
      label: "Docks",
      children: (
        <LayoutTool
          setShowShelf={setShowShelf}
          setDeleteElement={setDeleteElement}
          elementType={"dock"}
          setShowElementConfigPanel={setShowElementConfigPanel}
        />
      ),
    },
  ];

  const openBinsConfigurationModal = (element = null) => {
    if (element) {
      dispatch({ type: "SET_SELECTED_ELEMENT", payload: element });
    }
    setShowShelf(true);
  };

  const onTabChangeHandler = (selectedTabKey) => {
    setActiveTab(selectedTabKey);
  };

  const detectHandleClickOutside = (event) => {
    if (showColorPicker && colorPickerRef.current && !colorPickerRef.current.contains(event.target)) {
      setShowColorPicker(false);
    }
  };

  //Detect click outside to close color picker
  useEffect(() => {
    document.addEventListener("mousedown", detectHandleClickOutside);
    return () => {
      document.removeEventListener("mousedown", detectHandleClickOutside);
    };
  });

  return (
    <>
      {showElementConfigPanel ? (
        <Suspense
          fallback={
            <div className="fullscreen-loading">
              <div className="loading-overlay">
                <Spin size="large" />
              </div>
            </div>
          }
        >
          <ElementConfigPanel
            setShowElementConfigPanel={setShowElementConfigPanel}
            rackInfo={state.selectedElement}
            openBinsConfigurationModal={openBinsConfigurationModal}
          />
        </Suspense>
      ) : (
        <div className="layout-toolbar">
          <div className="layout-toolbar-inner">
            <div className="layout-toolbar-header">
              <h4 className="toolbar-title">
                Elements <span className="toolbar-count">{state.elements.length}</span>
              </h4>
              <Button size="small" className="saveAll-btn" loading={loading} onClick={saveAll}>
                Save All
              </Button>
            </div>
            <div className="layout-toolbar-tabs-wrapper">
              <Tabs defaultActiveKey="1" activeKey={activeTab} items={tabConfig} onChange={onTabChangeHandler} />
            </div>
          </div>
        </div>
      )}
    </>
  );
});

export default LayoutToolBar;
